import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FrameContainer = ({
  children,
  className = '',
  noMobilePadding = false,
  noPadding = false,
  wide = false,
}) => (
  <div
    className={classNames(
      `mx-auto my-0 px-5 py-8 md:border md:border-solid md:border-gray-light7 md:mb-[55px] md:mt-12 md:max-w-[468px] md:p-10 ${className}`,
      {
        'p-0': !!noMobilePadding,
        'p-0 md:p-0': !!noPadding,
        'md:max-w-[600px]': !!wide,
      }
    )}
  >
    {children}
  </div>
);

FrameContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noMobilePadding: PropTypes.bool,
  noPadding: PropTypes.bool,
  wide: PropTypes.bool,
};

export default FrameContainer;
